import * as React from "react";

type LogoProps = {
  fillColor?: string;
  height?: string;
  width?: string;
};

const Logo = ({ fillColor = "#002b69", width = "68.256", height = "49.189" }: LogoProps) => {
  return (
    <svg id="logo" xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 68.256 49.189">
      <g id="グループ_2239" data-name="グループ 2239">
        <path
          id="パス_2307"
          data-name="パス 2307"
          d="M66.756,46.189h-4.5V31.527a1.5,1.5,0,0,0-3,0V46.189H45.881V35.32a1.5,1.5,0,0,0-1.5-1.5h-8.9a1.5,1.5,0,0,0-1.5,1.5V46.189H29.444V31.527a1.5,1.5,0,0,0-3,0V46.189H8.728V3h29.28V13.137a1.5,1.5,0,0,0,3,0V1.5a1.5,1.5,0,0,0-1.5-1.5H7.228a1.5,1.5,0,0,0-1.5,1.5V46.189H1.5a1.5,1.5,0,0,0,0,3H66.756a1.5,1.5,0,0,0,0-3ZM36.981,36.82h5.9v9.369h-5.9Z"
          fill={fillColor}
        />
        <path
          id="パス_2308"
          data-name="パス 2308"
          d="M20.616,29.935a1.5,1.5,0,0,0,2.026.629L44.35,19.144l21.708,11.42a1.5,1.5,0,0,0,1.4-2.654L45.048,16.122a1.5,1.5,0,0,0-1.4,0L21.246,27.91a1.5,1.5,0,0,0-.629,2.025Z"
          fill={fillColor}
        />
        <path
          id="パス_2309"
          data-name="パス 2309"
          d="M17.94,8.389H14.263a1.655,1.655,0,0,0,0,3.31H17.94a1.655,1.655,0,1,0,0-3.31Z"
          fill={fillColor}
        />
        <rect
          id="長方形_1292"
          data-name="長方形 1292"
          width="6.986"
          height="3.309"
          rx="1.655"
          transform="translate(12.609 14.928)"
          fill={fillColor}
        />
        <rect
          id="長方形_1293"
          data-name="長方形 1293"
          width="6.986"
          height="3.309"
          rx="1.655"
          transform="translate(23.465 14.928)"
          fill={fillColor}
        />
        <path
          id="パス_2310"
          data-name="パス 2310"
          d="M25.12,11.7H28.8a1.655,1.655,0,1,0,0-3.31H25.12a1.655,1.655,0,1,0,0,3.31Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default Logo;
